import { Context, useContext } from 'react'

export const useProvideContext = <T>(contextType: Context<T>, name: string) => {
    const context = useContext(contextType)
    if (!context) throw new Error(`${name}Context must be used within a ${name}Provider`)
    return context
}
